// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2ky7M","inputDescription":"styles_inputDescription__3CZj7"};